import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { LogosettingComponent } from './logosetting.component';

const routes: Routes = [
  {
    path: '',
    component: LogosettingComponent,
    data: {
      title: ''
    }
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class LogosettingRoutingModule { }
